import { ShieldCheckIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import PageLayout from "@/pages/_components/Layout";
import getNavigationLinks from "../_sidebar/pageNavigationLinks";

export default function Layout(props) {
  const { t } = useTranslation();
  const pageLinks = getNavigationLinks()

  return (
    <PageLayout
      title={t('Steward')}
      breadcrumbs={[t('Workspace'), t('Steward')]}
      description={t('Coming soon.')}
      pageLinks={pageLinks}
    >
        <ShieldCheckIcon className="mx-auto h-12 w-12 text-gray-400" />
        <h3 className="mt-2 text-sm font-semibold text-gray-900">{t('New workspace coming soon')}</h3>
        <p className="mt-1 text-sm text-gray-500">{t('Coming soon')}</p>
    </PageLayout>
  );
}
